import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import { Section, Heading } from '@piggybank/core';
import { useSelector } from 'react-redux';
import { Translation, TranslationScope } from 'srcAlias/client/locale';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import {
  selectQueryParams,
  selectProductCode,
} from 'srcAlias/client/state/selectors';
import { getProductTypeLabels } from './getProductTypeLabels';
import { EQUITY_INVESTMENT_ACCOUNT } from 'srcAlias/client/enums/productDescriptionCode';
import { isMobileJourney } from 'srcAlias/client/utils/urlParameters';
import AccountNumberPanel from './AccountNumberPanel';
import AcceptPageInfoSection from './AcceptPageInfoSection';
import AcceptPageButtonSection from './AcceptPageButtonSection';
import hooks from 'hooksAlias';

const fullNameCss = {
  wordWrap: 'break-word',
};

export const Accept = ({
  segmentName,
  pageName,
  customerData,
  applicationDecisionData,
}) => {
  const productType = useSelector(selectProductCode); //SEC_HBSP

  const productID = useSelector((state) =>
    get(state, 'productSelection.productType', '')
  ); //BONDS

  const queryParams = useSelector(selectQueryParams);
  const mobileJourney = isMobileJourney(queryParams);

  const initialValuesForm = {};

  const AcceptPageConfirmation = get(
    hooks,
    'decision.success.AcceptPageConfirmation',
    () => null
  );
  const HorizontalRuleHook = get(
    hooks,
    'horizontalRule.HorizontalRuleHook',
    () => null
  );

  const CalloutMobilex = get(
    hooks,
    'decision.callout.CalloutMobilex',
    () => null
  );
  if (productType === EQUITY_INVESTMENT_ACCOUNT) {
    initialValuesForm.marketsAcceptPageCheckbox = {
      US: false,
      HK: false,
    };
  }

  useTrackPageViewAnalytics('accept');
  return (
    <TranslationScope path={`${segmentName}.${pageName}`}>
      <HorizontalRuleHook />
      <Section marginBottom={3}>
        <AcceptPageConfirmation />
        <Heading level={1} style={fullNameCss}>
          <Translation path="heading" />
          {get(customerData, 'individualDetail.name.fullName', '').slice(0, 70)}
          <Translation
            path={get(
              getProductTypeLabels,
              `${productType}_${productID}.heading`,
              ''
            )}
          />
        </Heading>
      </Section>
      <Section>
        <AccountNumberPanel
          applicationDecisionData={applicationDecisionData}
          selectedProduct={{
            productCode: productType,
            productType: productID,
          }}
        />
        <AcceptPageInfoSection
          productType={productType}
          productID={productID}
          applicationDecisionData={applicationDecisionData}
        />
      </Section>

      {mobileJourney && <CalloutMobilex />}

      <AcceptPageButtonSection
        pageName={pageName}
        productType={productType}
        productID={productID}
        mobileJourney={mobileJourney}
        queryParams={queryParams}
        initialValuesForm={initialValuesForm}
      />
    </TranslationScope>
  );
};

Accept.propTypes = {
  segmentName: T.string,
  pageName: T.string,
  customerData: T.object,
  applicationDecisionData: T.object,
};
